type AppendWalletConnectUriToDeepLinkParams = {
  deepLinkUrl: string;
  walletConnectUri: string;
};

/**
 * Appends a WalletConnect URI to a deep link URL.
 *
 * Determines the appropriate query parameter separator (? or &) based on whether
 * the deep link already contains query parameters.
 *
 * @param params.deepLinkUrl - The base deep link URL (e.g., "walletapp://wc" or "walletapp://wc?param=value")
 * @param params.walletConnectUri - The WalletConnect pairing URI to append
 * @returns The deep link URL with the WalletConnect URI appended as a query parameter
 *
 * @example
 * ```ts
 * appendWalletConnectUriToDeepLink({ deepLinkUrl: 'walletapp://wc', walletConnectUri: 'wc:123-456' })
 * // Returns: 'walletapp://wc?uri=wc%3A123-456'
 *
 * appendWalletConnectUriToDeepLink({ deepLinkUrl: 'walletapp://wc?param=value', walletConnectUri: 'wc:123-456' })
 * // Returns: 'walletapp://wc?param=value&uri=wc%3A123-456'
 * ```
 */
export const appendWalletConnectUriToDeepLink = ({
  deepLinkUrl,
  walletConnectUri,
}: AppendWalletConnectUriToDeepLinkParams): string => {
  const url = new URL(deepLinkUrl);

  url.searchParams.set('uri', walletConnectUri);

  return url.href;
};
